<template>
  <div class="result-wrapper q-pa-md">
    <h2>
      <i></i>
      <b></b>
      <span>投票结果</span>
      <b></b>
      <i></i>
    </h2>
    <div class="chart" v-for="(item, index) in result" :key="item.title">
      <ResultItem
        :id="`question${index+1}`"
        :number="`${index+1}`"
        :title="item.title"
        :yAxis="item.options.labels"
        :data="item.options.values"
      ></ResultItem>
    </div>
    <p class="copyright link" v-if="hasResult">
      如有还未报名参选的机构，可通过以下链接报名参与，之后将被添加到上述投票机构列表中，
      链接：
      <a
        href="https://wj.qq.com/s2/3513427/48ee/"
        target="_blank"
      >https://wj.qq.com/s2/3513427/48ee/</a>，
      完成报名之后，我们的工作人员将会联系你并做进一步信息收集。此次评选的计分将包涵行业调研、专家评审、大众投票三个部分。需要注意的是，在最终统计时，只有完整报名的机构才能获得专家评审部分的计分。
    </p>
    <p class="copyright" v-if="hasResult">*本活动解释权归懒熊体育所有</p>
  </div>
</template>
<script>
import ResultItem from '@/components/ResultItem'
import request from '@/utils/request'
import { list } from '../Home/questions.js'
import { result } from './result'
export default {
  data() {
    return {
      result: null,
      hasResult: false
    }
  },
  components: {
    ResultItem
  },
  async mounted() {
    const res = await request('/selection/get')
    const _res = res.data[0]

    const list = ["自由者健身", "ZESPEED", "中体倍力", "中健健身", "中航健身", "英派斯健身", "引力工场", "银吉姆", "一兆韦德", "蚁加私教", "壹健身", "XONE运动空间", "星之健身", "威尔士", "SpaceCycle", "舒适堡", "Shape", "人马线", "人马君", "清橙健身", "青鸟健身", "奇迹健身", "Pure", "魔方运动", "美格菲", "力美健", "Liking健身", "练遇健身", "乐刻运动", "快快健身", "Keepland", "K-EMS Studio", "JUMPFIT", "金吉鸟", "杰仕动能", "嘉佑健身", "健身者联盟", "Hyperfit", "黄金时代健身", "浩沙健身", "光猪圈", "古德菲力", "蜂狂运动", "FitU/飞优", "第一体育", "超级猩猩", "宝力豪", "b-monster", "奥美氧舱", "安体倍力", "24KiCK"]

    result.map((item, index) => {
      const _item = _res[`questionNum${index + 1}`]
      const values = []
      list.forEach(item => {
        values.push(_item[item])
      })

      item.options.labels = list
      item.options.values = values

      return _item
    })


    // result.map((item) => {
    //   // item.options.labels
    //   // item.options.values
    //   return item
    // })

    this.result = result
    document.body.scrollTop = 0
    this.hasResult = true
  },
}
</script>
<style lang="scss" src="./index.scss">
</style>
